import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

export const getClientAppointmentList = createAsyncThunk("client/list-appointment", async (token, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/client/list-appointment`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    // console.log("data", res.data.appointmentList);
    return res.data.appointmentList;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch client appointments");
  }
});

export const updateClientAppointment = createAsyncThunk(
  "client/update-appointment",
  async ({ token, formData, appointmentId }, thunkAPI) => {
    try {
      const res = await axios.post(
        `${BACKEND_URL}/client/update-appointment/${appointmentId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to update appointment"
      );
    }
  }
);

export const deleteClientAppointment = createAsyncThunk(
  "client/delete-appointment",
  async ({ token, appointmentId  }, thunkAPI) => {
    try {
      const res = await axios.delete(
        `${BACKEND_URL}/client/delete-appointment/${appointmentId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to delete client appointment"
      );
    }
  }
);

const clientAppointmentSlice = createSlice({
  name: "clientAppointment",
    initialState: {
      clientsAppointment: null,
      loading: false,
      error: null,
    },
    extraReducers: (builder) => {
      builder
        .addCase(getClientAppointmentList.pending, (state) => {
            state.loading = true;
        })
        .addCase(getClientAppointmentList.fulfilled, (state, action) => {
            state.clientsAppointment = action.payload;
            state.loading = false;
        })
        .addCase(getClientAppointmentList.rejected, (state, action) => {
            state.error = action.payload || "Failed to fetch client appointment"; 
            state.loading = false;
        })
        .addCase(deleteClientAppointment.pending, (state) => {
            state.loading = true;
        })
        .addCase(deleteClientAppointment.fulfilled, (state, action) => {
            state.loading = false;
        })
        .addCase(deleteClientAppointment.rejected, (state, action) => {
            state.error = action.payload || "Failed to delete appointment";
            state.loading = false;
        })
    }
});

export default clientAppointmentSlice.reducer;